interface CustomerViewFlags {
    is_accordion_view_active?: unknown;
    is_category_view_active?: unknown;
    categories?: unknown;
}

export const hasCategoryViewFlags = (customer: CustomerViewFlags | null | undefined): boolean =>
    Boolean(customer?.is_accordion_view_active) || Boolean(customer?.is_category_view_active);

export const hasCategoryBrowser = (customer: CustomerViewFlags | null | undefined): boolean =>
    hasCategoryViewFlags(customer) &&
    Object.keys((customer?.categories as Record<string, unknown> | undefined) ?? {}).length > 0;
